import { C } from "@/brand/tokens";
import { process6 } from "@/brand/contentF6";
import { Eyebrow6 } from "@/components/common/Eyebrow6";
import { TextLink6 } from "@/components/common/TextLink6";
import { ProcessSteps6 } from "./ProcessSteps6";

/** ProcessSection6 — four boxed, numbered steps + a modest CTA beneath. */
export function ProcessSection6() {
  return (
    <section id="process" data-testid="process-6" style={{ background: C.surfaceLight, color: C.textOnLight }}>
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-10 py-20 lg:py-24">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
          <div>
            <Eyebrow6 className="mb-5">{process6.eyebrow}</Eyebrow6>
            <h2
              className="font-cormorant"
              style={{ color: C.textOnLight, fontSize: "clamp(1.8rem, 3.2vw, 2.6rem)", fontWeight: 400, lineHeight: 1.08, maxWidth: "24ch" }}
            >
              {process6.headline}
            </h2>
          </div>
          <TextLink6 to={process6.cta.href} testId="process-cta">
            {process6.cta.label}
          </TextLink6>
        </div>

        <ProcessSteps6 tone="parchment" />
      </div>
    </section>
  );
}
